import Triple from './Triple'

export default Triple